import {
  Typography,
  Avatar,
  Box,
  List,
  ListItem,
  Divider,
} from '@mui/material';
import { Link } from 'react-router';
import { useQuery, gql } from 'urql';

import { Button } from '@/components/ui/button';
import { useUser } from '@/components/auth-provider';
import { getInitials, getFirstAndLastName } from '../../../utils';
import ErrorBanner from '../../banners/ErrorBanner';

const CURRENT_USER_QUERY = gql`
  query getUser($id: Int!) {
    userDetails(id: $id) {
      companiesId
      email
      id
      name
      phone
    }
  }
`;

export default function UserAccount() {
  const { user } = useUser();
  const [{ data, error }] = useQuery({
    pause: !user,
    query: CURRENT_USER_QUERY,
    variables: {
      id: Number(user?.id),
    },
  });

  const userInitial = getInitials(data?.userDetails?.name);
  const { firstName, lastName } = getFirstAndLastName(data?.userDetails?.name);

  if (error) {
    return (
      <ErrorBanner>
        <Typography variant="body2" color="error">
          Something happened, try refreshing the page. If the issue persists,
          contact our support email for help.
        </Typography>
      </ErrorBanner>
    );
  }

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      gap="48px"
    >
      <Avatar
        sx={{
          height: '72px',
          width: '72px',
          fontSize: '24px',
          fontWeight: 600,
          bgcolor: 'avatar.main',
        }}
      >
        {userInitial}
      </Avatar>
      <Box
        display="flex"
        justifyContent="space-between"
        width="480px"
        alignItems="center"
      >
        <Typography variant="body1" fontSize="18px">
          Account Information
        </Typography>
        <Link to="/account/edit">
          <Button variant="outline">Edit</Button>
        </Link>
      </Box>
      <List
        sx={{
          width: '480px',
          '& .MuiListItemText-root': { fontSize: '14px' },
        }}
      >
        <ListItem disablePadding>
          <Box
            display="flex"
            justifyContent="space-between"
            width="100%"
            paddingY="12px"
          >
            <Typography variant="body2" sx={{ color: 'secondary.dark' }}>
              First name
            </Typography>
            <Box display="flex" justifyContent="flex-start" width="372px">
              <Typography variant="body2">{firstName}</Typography>
            </Box>
          </Box>
        </ListItem>
        <Divider />
        <ListItem disablePadding>
          <Box
            display="flex"
            justifyContent="space-between"
            width="100%"
            paddingY="12px"
          >
            <Typography variant="body2" sx={{ color: 'secondary.dark' }}>
              Last name
            </Typography>
            <Box display="flex" justifyContent="flex-start" width="372px">
              <Typography variant="body2">{lastName}</Typography>
            </Box>
          </Box>
        </ListItem>
        <Divider />
        <ListItem disablePadding>
          <Box
            display="flex"
            justifyContent="space-between"
            width="100%"
            paddingY="12px"
          >
            <Typography variant="body2" sx={{ color: 'secondary.dark' }}>
              Email
            </Typography>
            <Box display="flex" justifyContent="flex-start" width="372px">
              <Typography variant="body2">
                {data?.userDetails?.email}
              </Typography>
            </Box>
          </Box>
        </ListItem>
        <Divider />
        <ListItem disablePadding>
          <Box
            display="flex"
            justifyContent="space-between"
            width="100%"
            paddingY="12px"
          >
            <Typography variant="body2" sx={{ color: 'secondary.dark' }}>
              Phone number
            </Typography>
            <Box display="flex" justifyContent="flex-start" width="372px">
              <Typography variant="body2">
                {data?.userDetails?.phone}
              </Typography>
            </Box>
          </Box>
        </ListItem>
      </List>
    </Box>
  );
}
